import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsPrice } from 'integration/generated/transactions';
import { RequestParams } from 'integration/generated/transactions/http-client';
import useSWR from 'swr';

type PriceByQuery = {
	q?: 'byPartNumbers' | 'byCatalogEntryIds';
	partNumber?: string[] | string;
	catalogEntryId?: string[] | string;
	contractId?: string;
	currency?: 'MXN';
	quantity?: string;
	uom?: string;
	date?: string;
	checkEntitlement?: 'true' | 'false';
	dynamicKitAsItem?: 'true' | 'false';
	profileName?: 'IBM_Store_EntitledPrice_All' | 'IBM_Store_EntitledPrice_RangePrice_All';
};

export const priceByFetcher =
	(pub: boolean) => async (storeId: string, query: PriceByQuery, params: RequestParams) => {
		const response = await transactionsPrice(pub).priceByPartNumbers(storeId, query as any, params);
		return response;
	};

const DATA_KEY_PRICE_BY = 'PriceBy';

const defaultQuery: PriceByQuery = {
	q: 'byCatalogEntryIds',
	checkEntitlement: 'false',
	profileName: 'IBM_Store_EntitledPrice_RangePrice_All',
	currency: 'MXN',
};

export const usePriceBy = (args?: PriceByQuery) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();

	const rawSwr = useSWR(
		storeId && (args?.catalogEntryId || args?.partNumber)
			? [{ storeId, ...{ ...defaultQuery, ...args } }, DATA_KEY_PRICE_BY]
			: null,
		async ([{ storeId, ...query }]) => priceByFetcher(true)(storeId, query, params)
	);

	return rawSwr;
};
